<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "views-administrator-backoffice-bets",
  mounted() {
    if (this.$route.name == "AdministratorBets") {
      this.$router
        .push({
          name: "ChartOnline",
        })
        .catch(() => {});
    }
  },
  watch: {
    $route(val) {
      if (val.name == "AdministratorBets") {
        this.$router
          .push({
            name: "ChartOnline",
          })
          .catch(() => {});
      }
    },
  },
};
</script>
